import { local, dev, qa, uat, prod } from "@/utils/Environment.js";

export const loadConfig = () => {
  const environment = import.meta.env.VITE_NODE_ENV;
  const apiKey = import.meta.env.VITE_NODE_API_KEY;
  sessionStorage.setItem("apiKey", apiKey);

  switch (environment) {
    case "dev":
      return dev;
    case "qa":
      return qa;
    case "uat":
      return uat;
    case "prod":
      return prod;
    default:
      return local;
  }
};
